const measureConnectionSpeed = async () => {
  const imageUrl = '/test-speed.png';
  const attempts = 3;
  let totalDuration = 0;

  for (let i = 0; i < attempts; i++) {
    const start = performance.now();
    try {
      await fetch(`${imageUrl}?t=${Date.now()}`, { cache: 'no-store' });
    } catch (e) {
      return 1500;
    }
    const end = performance.now();
    totalDuration += end - start;
  }

  const avgDuration = totalDuration / attempts;

  if (avgDuration < 150) return 700;
  if (avgDuration < 350) return 1100;
  if (avgDuration < 800) return 1400;
  return 1500;
};

export default measureConnectionSpeed;
